// extracted by mini-css-extract-plugin
export default {"tableHeader":"PalletsPricingPerAddress_tableHeader__NwCoT"};